/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GlobalSettingsDto } from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getGlobalSettings = (
  oktaUserId: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GlobalSettingsDto>(
    { url: `/api/${oktaUserId}/global-settings`, method: 'GET', signal },
    options
  );
};

export const getGetGlobalSettingsQueryKey = (oktaUserId: string) => {
  return [`/api/${oktaUserId}/global-settings`] as const;
};

export const getGetGlobalSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGlobalSettings>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGlobalSettings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGlobalSettingsQueryKey(oktaUserId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGlobalSettings>>
  > = ({ signal }) => getGlobalSettings(oktaUserId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!oktaUserId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGlobalSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetGlobalSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGlobalSettings>>
>;
export type GetGlobalSettingsQueryError = ErrorType<unknown>;

export function useGetGlobalSettings<
  TData = Awaited<ReturnType<typeof getGlobalSettings>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGlobalSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGlobalSettings>>,
          TError,
          Awaited<ReturnType<typeof getGlobalSettings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGlobalSettings<
  TData = Awaited<ReturnType<typeof getGlobalSettings>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGlobalSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGlobalSettings>>,
          TError,
          Awaited<ReturnType<typeof getGlobalSettings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGlobalSettings<
  TData = Awaited<ReturnType<typeof getGlobalSettings>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGlobalSettings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetGlobalSettings<
  TData = Awaited<ReturnType<typeof getGlobalSettings>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGlobalSettings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetGlobalSettingsQueryOptions(oktaUserId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_REPORT_ADMIN**<br /><br />
 */
export const updateGlobalSettings = (
  oktaUserId: string,
  globalSettingsDto: BodyType<GlobalSettingsDto>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<GlobalSettingsDto>(
    {
      url: `/api/${oktaUserId}/global-settings`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: globalSettingsDto,
      signal,
    },
    options
  );
};

export const getUpdateGlobalSettingsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGlobalSettings>>,
    TError,
    { oktaUserId: string; data: BodyType<GlobalSettingsDto> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGlobalSettings>>,
  TError,
  { oktaUserId: string; data: BodyType<GlobalSettingsDto> },
  TContext
> => {
  const mutationKey = ['updateGlobalSettings'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGlobalSettings>>,
    { oktaUserId: string; data: BodyType<GlobalSettingsDto> }
  > = (props) => {
    const { oktaUserId, data } = props ?? {};

    return updateGlobalSettings(oktaUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGlobalSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGlobalSettings>>
>;
export type UpdateGlobalSettingsMutationBody = BodyType<GlobalSettingsDto>;
export type UpdateGlobalSettingsMutationError = ErrorType<unknown>;

export const useUpdateGlobalSettings = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateGlobalSettings>>,
      TError,
      { oktaUserId: string; data: BodyType<GlobalSettingsDto> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateGlobalSettings>>,
  TError,
  { oktaUserId: string; data: BodyType<GlobalSettingsDto> },
  TContext
> => {
  return useMutation(
    getUpdateGlobalSettingsMutationOptions(options),
    queryClient
  );
};
